// extracted by mini-css-extract-plugin
export var csatScore = "_i1-5";
export var header = "_i1-1";
export var panelWrapper = "_i1-2";
export var postPreview = "_i1-3";
export var rightContent = "_i1-0";
export var wrappingText = "_i1-4";